import { getAllergySearchList } from '../../actions'
import DOMPurify from 'dompurify';

export class HealthHistoryAllergyForm {
  constructor(el) {
    //Allergy Elements
    this.allergySearchField = el.querySelector('[data-component="allergy-search"]')
    this.allergyResultList = el.querySelector('#allergy-result-list')
    this.medicationAllergySelectionList = el.querySelector('#allergy-selection-list')
    this.allergyAddNewReactions = el.querySelectorAll('#medication-allergy-selection-list .add-new-reaction')
    //Medication Event Listeners
    if (this.allergySearchField) {
      this.calendarIconPath = el.querySelector('input#calendar_icon_path').value
      this.allergySearchField.addEventListener('keyup', (e) => this.onAllergySearchFieldChange(e, this.allergyResultList))
      this.allergyResultList.addEventListener('click', (e) => this.onAllergyMedicationSelection(e))
      this.allergyResultList.addEventListener('keyup', (e) => this.onAllergyMedicationSelection(e))
      this.medicationAllergySelectionList.addEventListener('click', (e) => this.handleMedicationEntryClicks(e))
      this.medicationAllergySelectionList.addEventListener('keyup', (e) => this.handleMedicationEntryClicks(e))
      this.medicationAllergySelectionList.addEventListener('change', (e) => this.handleMedicationEntryClicks(e))

      this.medicationAllergySelectionList.innerHTML = DOMPurify.sanitize(sessionStorage.medicationAllergySelectionList || '')

      this.medicationAllergySelectionList.querySelectorAll('div.dp-container input').forEach((item) => {
        this.intakeMDYDatePickerInitialize(item)
      })
    }

    //Allergy Event Listeners
    this.allergyAddNewReactions.forEach((item) => {
      item.addEventListener('click', (e) => this.onAllergyAddNewReaction(e))
    })
  }

  onAllergySearchFieldChange(event, allergyResultList) {
    if (event.srcElement.value.length > 2) {
      allergyResultList.classList.add('searching')
      allergyResultList.innerHTML = '<li>Loading ...</li>'
      getAllergySearchList({ search_term: event.srcElement.value, athena_context_id: event.srcElement.dataset.athenaContextId }).then(function (results) {
        let medicationListItems = ''
        results.data.forEach(function (result) {
          medicationListItems +=
            '<li data-allergyid="' + result.allergyid + '" tabindex="0">' + result.allergy + '</li>'
        })
        if (medicationListItems.length == 0) {
          medicationListItems = '<li>No medications found. Please try another search term.</li>'
        }
        allergyResultList.innerHTML = medicationListItems
      })
    } else {
      allergyResultList.innerHTML = ''
      allergyResultList.classList.remove('searching')
    }
  }

  handleMedicationEntryClicks(event) {
    // return false if keyboard event is not enter key
    if (this.isNotEnterClick(event)) {
      return false
    }

    // check for request to close element
    this.removeEntryCheck(event, this.medicationAllergySelectionList, 'medicationAllergySelectionList')
  }

  removeEntryCheck(event, list, listType) {
    if (event.target && event.target.classList.contains('remove-medication')) {
      list.removeChild(event.target.closest('li'))
      sessionStorage.setItem(listType, list.innerHTML)
    }
  }
  saveDateChanges(event, list, listType) {
    if (event.target && event.target.className == 'datepicker' && event.type == 'change') {
      event.target.setAttribute('value', event.target.value)
      this.setHtmlSegment(listType, list.innerHTML, true)
    }
  }


  onAllergyMedicationSelection(event) {
    if (this.isNotEnterClick(event) || typeof event.target.dataset.allergyid == 'undefined') {
      return false
    }
    this.createMedicationEntry(event.target.innerText, event.target.dataset.allergyid)
    this.allergyResultList.innerHTML = ''
    this.allergyResultList.classList.remove('searching')
    this.allergySearchField.value = ''
  }

  createMedicationEntry(name, id) {
    let key = new Date().getTime()
    this.setHtmlSegment('medicationAllergySelectionList',
      `<li>
        <input
          name="telemedicine_intakes_v2_health_history_allergy_form[intake_health_history_allergies][${key}][allergyid]"
          value="${id}"
          type="hidden"
        />
        <input
          name="telemedicine_intakes_v2_health_history_allergy_form[intake_health_history_allergies][${key}][medication_name]"
          value="${name}"
          type="hidden"
        />
        <div class="datepicker-wrapper">
          <label for="intake_health_history_allergies_${key}_onsetdate">
            Approximately when did the <b>${name}</b> allergy onset date begin?<span class="required">*</span>
          </label>
          <div class="dp-container">
            <input
              id="intake_health_history_allergies_${key}_onsetdate"
              name="telemedicine_intakes_v2_health_history_allergy_form[intake_health_history_allergies][${key}][onsetdate]"
              type="text"
              class="datepicker"
              placeholder="Please pick a date"
              data-mode="date"
              role="combobox"
              aria-haspopup="dialog" 
              aria-expanded="false" 
              autocomplete="off" 
              readonly="readonly"
              data-end-date="${new Date().toLocaleDateString('en-US')}"
              required="required"
            />
            <img src="${this.calendarIconPath}" alt="Privia Health" class="patcom-calendar-image pick-a-date" />
            <i class="fas fa-times remove-medication"></i>
          </div>
        </div>
      </li>`
    )
  }

  setHtmlSegment(name, content, override = false) {
    content = (sessionStorage.getItem(name) && !override) ? content + sessionStorage.getItem(name) : content
    sessionStorage.setItem(name, content)
    this[name].innerHTML = DOMPurify.sanitize(content)

    this[name].querySelectorAll('div.dp-container input').forEach((item) => {
      this.intakeMDYDatePickerInitialize(item)
    })
  }

  isNotEnterClick(event) {
    return (event instanceof KeyboardEvent && event.which != 13)
  }

  /*
    vendor/jquery-1.7.2 and bootstrap-datepicker are necessary to make this method work
    which are declared in app/assets/javascripts/telemedicine_intakes_v2.js
  */
  intakeMDYDatePickerInitialize(item) {
    let that = this

    // DatePicker recreation
    new DatePicker(item)

    jQuery(item).on('change', function (e) {
      // Check for date changes and save to session
      that.saveDateChanges(e, that.medicationAllergySelectionList, 'medicationAllergySelectionList')
    })
  }

  onAllergyAddNewReaction(event) {
    // Locates the target containers
    let actionContainer = event.target.closest('.actions')
    let mainContainer = actionContainer.parentNode

    // Prepares the row remplate for new allergy reaction and creates the element for that
    let rowTemplate = atob(event.target.dataset.rowtemplate, 'base64').replace(new RegExp('__id__', 'g'), new Date().getTime())

    let templateElement = document.createElement("template")
    templateElement.innerHTML = DOMPurify.sanitize(rowTemplate)

    let rowElement = templateElement.content.firstChild

    // Inserts the element at the bottom of the target container
    mainContainer.insertBefore(rowElement, actionContainer)

    // Sets the remove action event to the new element
    rowElement.querySelector('.remove-medication').addEventListener('click', (e) => {
      e.target.closest('.allergy-row').remove()
    })
  }
}